import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './timer.module.css';

interface TimerProps {
  dontShowText?: boolean;
}

export const Timer: React.FC<TimerProps> = ({ dontShowText }) => {
  const { t } = useTranslation(['form']);
  const [timeLeft, setTimeLeft] = useState(20);
  const [totalTime, setTotalTime] = useState(20);
  const [iteration, setIteration] = useState(1);

  useEffect(() => {
    if (timeLeft === 0 && iteration < 4) {
      setIteration(iteration + 1);
      const newTotalTime = 20 * iteration * 3;
      setTimeLeft(newTotalTime);
      setTotalTime(newTotalTime);
    }
  }, [timeLeft, iteration]);

  useEffect(() => {
    if (iteration < 4) {
      const timer = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timeLeft, iteration]);

  const radius = 90;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = (timeLeft / totalTime * circumference).toFixed(2);

  const messages = [
  t('timer.thinkingShortest'),
  t('timer.thinkingShort'),
  t('timer.thinkingLong'),
  t('timer.thinkingBroken')];


  return (
    <div className="flex flex-col items-center text-primary-400">
			<p>{!dontShowText && messages[iteration - 1]}</p>
			{iteration < 4 &&
      <div className={styles.timer}>
					<svg>
						<circle cx="50%" cy="50%" r={radius} className={styles.circle} />
						<circle
            cx="50%"
            cy="50%"
            r={radius}
            className={styles.progress}
            style={{ strokeDasharray: circumference, strokeDashoffset }} />

						<text
            x="100"
            y="100"
            textAnchor="middle"
            style={{ fill: '#172b4d' }}>

							{timeLeft}
						</text>
						<text
            x="100"
            y="120"
            textAnchor="middle"
            style={{ fill: '#172b4d' }}>

							{t('timer.seconds')}
						</text>
					</svg>
				</div>}

		</div>);

};